import React, { useState } from "react";
import ChatCRMit from "../../../pages/Prototyping/ChatCRMit";
import { Box, IconButton, Tooltip } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import { useBranding } from "../../branding/Branding";

const developer =
  JSON.parse(localStorage.getItem("authUser"))?.get_user_data
    ?.User_FlagDeveloper === "1";

const ChatCrmitPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isBrandingActive } = useBranding();

  const toggleChatPopup = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      {developer && (
        <Box sx={{ position: "fixed", bottom: 16, right: 16, zIndex: 999 }}>
          {!isOpen && (
            <Tooltip title="Open Chat" arrow>
              <IconButton
                onClick={toggleChatPopup}
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#1565c0" },
                  boxShadow: 3,
                }}
              >
                <ChatIcon />
              </IconButton>
            </Tooltip>
          )}

          {isOpen && (
            <Box
              sx={{
                position: "fixed",
                bottom: 16,
                right: 16,
                width: "350px",
                height: "60vh",
                backgroundColor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {/* Sticky Header with Close Button */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 16px",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                }}
              >
                <Tooltip title="Close Chat" arrow>
                  <IconButton onClick={toggleChatPopup} sx={{ color: "#fff" }}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
                <Box
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    marginRight: "40px", // Ensures title is centered with close button
                  }}
                >
                  {isBrandingActive ? "CRMit Assistant" : "AI Assistant"}
                </Box>
              </Box>

              {/* Chat Content */}
              <ChatCRMit popup={true} />
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default ChatCrmitPopup;
